import { render } from "./msgPushForm.vue?vue&type=template&id=5ae1d0d7"
import script from "./msgPushForm.vue?vue&type=script&lang=js"
export * from "./msgPushForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\vue\\ydd-zht-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__